export default __webpack_public_path__ + "4b9683893e80daffcb0ab8132a72a762.svg";